import {SiteModel} from "./SiteModel";

export class PreCleaningModel {

//Fields
  private _site: SiteModel

  constructor (site: SiteModel){
    this._site = site
  }

  getSiteModel() {
    return this._site;
  }

}
